export function repeat(value, times) {
    var array = [];
    for (var i = 0; i < times; i++) {
        array[i] = value;
    }
    return array;
}
//# sourceMappingURL=util.js.map